import React, { useState, useEffect } from 'react';
import { Phone, Mail, Menu, X, Instagram } from 'lucide-react';
import { businessInfo } from '../data/mock';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white/95 backdrop-blur-sm shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-2">
          {/* Logo */}
          <div className="flex items-center gap-2">
            <img 
              src="/images/branding/logo.png" 
              alt="Marina Homes Logo" 
              className="h-12 w-auto"
            />
            <h1 className="text-xl font-bold text-amber-900 hidden sm:block">{businessInfo.name}</h1>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-6">
            <button 
              onClick={() => scrollToSection('home')}
              className="text-gray-700 hover:text-amber-700 transition-colors font-medium text-sm"
            >
              Home
            </button>
            <button 
              onClick={() => scrollToSection('gallery')}
              className="text-gray-700 hover:text-amber-700 transition-colors font-medium text-sm"
            >
              Gallery
            </button>
            <button 
              onClick={() => scrollToSection('booking')}
              className="text-gray-700 hover:text-amber-700 transition-colors font-medium text-sm"
            >
              Book Now
            </button>
            <button 
              onClick={() => scrollToSection('reviews')}
              className="text-gray-700 hover:text-amber-700 transition-colors font-medium text-sm"
            >
              Reviews
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className="text-gray-700 hover:text-amber-700 transition-colors font-medium text-sm"
            >
              Contact
            </button>
          </nav>

          {/* Contact Info & Instagram (Desktop) */}
          <div className="hidden lg:flex items-center space-x-3">
            <a 
              href="https://www.instagram.com/marinahomestz"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center space-x-1 text-pink-600 hover:text-pink-700 transition-colors"
              title="Follow us on Instagram"
            >
              <Instagram size={18} />
              <span className="text-sm font-medium">Instagram</span>
            </a>
            <span className="text-gray-300">|</span>
            <a 
              href={`tel:${businessInfo.phone}`}
              className="flex items-center space-x-1 text-gray-700 hover:text-amber-700 transition-colors"
            >
              <Phone size={16} />
              <span className="text-sm font-medium">{businessInfo.phone}</span>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden text-gray-700 hover:text-amber-700 transition-colors"
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-200">
            <nav className="flex flex-col space-y-4">
              <button 
                onClick={() => scrollToSection('home')}
                className="text-gray-700 hover:text-amber-700 transition-colors font-medium text-left"
              >
                Home
              </button>
              <button 
                onClick={() => scrollToSection('gallery')}
                className="text-gray-700 hover:text-amber-700 transition-colors font-medium text-left"
              >
                Gallery
              </button>
              <button 
                onClick={() => scrollToSection('booking')}
                className="text-gray-700 hover:text-amber-700 transition-colors font-medium text-left"
              >
                Book Now
              </button>
              <button 
                onClick={() => scrollToSection('reviews')}
                className="text-gray-700 hover:text-amber-700 transition-colors font-medium text-left"
              >
                Reviews
              </button>
              <button 
                onClick={() => scrollToSection('contact')}
                className="text-gray-700 hover:text-amber-700 transition-colors font-medium text-left"
              >
                Contact
              </button>
              <div className="pt-4 border-t border-gray-200 space-y-2">
                <a 
                  href="https://www.instagram.com/marinahomestz"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center space-x-2 text-pink-600 hover:text-pink-700 transition-colors"
                >
                  <Instagram size={18} />
                  <span className="text-sm font-medium">Follow on Instagram</span>
                </a>
                <a 
                  href={`tel:${businessInfo.phone}`}
                  className="flex items-center space-x-2 text-gray-700 hover:text-amber-700 transition-colors"
                >
                  <Phone size={18} />
                  <span className="text-sm font-medium">{businessInfo.phone}</span>
                </a>
                <a 
                  href={`mailto:${businessInfo.email}`}
                  className="flex items-center space-x-2 text-gray-700 hover:text-amber-700 transition-colors"
                >
                  <Mail size={18} />
                  <span className="text-sm font-medium">{businessInfo.email}</span>
                </a>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
